import { post, get, formPost } from "../../js/http";
import { commonFunc } from "../../js/util";
$(document).ready(function () {
  // 手机访问PC网站跳转h5
  !(function () {
    var devices = ["iPhone", "Android", "Windows Phone"];
    var ua = window.navigator.userAgent;
    for (var i = 0; i < devices.length; i++) {
      if (ua.indexOf(devices[i]) != -1) {
        window.location.href = "https://m.51callme.com";
      }
    }
  })();

  layui.use(["layer"], function () {
    var $ = layui.jquery,
      layer = layui.layer;

    $("#privacyBtn").click(function () {
      post("/ApiHome/ApiAction?_ControlName=GetInformationConfigByPC", {
        KeyName: "UserPrivacyPolicy",
      }).then((res) => {
        if (res.ReturnStatus) {
          let aboutusStr = res.Data.InfoConfig.KeyValue;
          commonFunc(aboutusStr);
        }
      });
    });
    $("#aggrementBtn").click(function () {
      post("/ApiHome/ApiAction?_ControlName=GetInformationConfigByPC", {
        KeyName: "UserServiceAgreement",
      }).then((res) => {
        if (res.ReturnStatus) {
          let aboutusStr = res.Data.InfoConfig.KeyValue;
          commonFunc(aboutusStr);
        }
      });
    });
    $("#aboutusBtn").click(function () {
      let aboutusStr =
        "<ul style='font-size:16px;line-height: 30px;'><li>考米小客服的QQ：3210820541</li><li>客服电话：0755-82669662 转 8013（工作日 10:00-22:00）</li><li>商务合作QQ：3243529464</li></ul>";
      commonFunc(aboutusStr);
    });
  });
});
